import { useContext } from "react";
import { ClientLibraryPicker, type RunDialogPageProps } from "..";
import { RunWith, RunWithContext } from "../../api-playground/run-with";
import AuthToken from "../../auth-token";
import { useRunDialogContext } from "../context";
import GetStartedCurl from "../get-started-curl.mdx";
import GetStartedJavaScript from "../get-started-javascript.mdx";
import GetStartedPython from "../get-started-python.mdx";
import { MDXPageWithToc } from "../mdx-page-with-toc";
import { GettingStartedContext } from "../snippets";

export function GetStartedPage({
  example,
  model,
  token,
  usesVersionlessApi,
  version,
}: RunDialogPageProps) {
  const { language } = useRunDialogContext();

  const Content = (() => {
    switch (language) {
      case RunWithContext.NodeJS:
        return GetStartedJavaScript;
      case RunWithContext.Python:
        return GetStartedPython;
      case RunWithContext.HTTP:
        return GetStartedCurl;
      default:
        throw new Error(`Unexpected language: ${language}`);
    }
  })();

  const gsp = useContext(GettingStartedContext);

  return (
    <MDXPageWithToc language={language} id="get-started">
      <Content
        components={{
          AuthToken: AuthToken,
          ClientLibraryPicker: () => <ClientLibraryPicker />,
          // TODO: Delete this
          RunWith: () =>
            usesVersionlessApi ? (
              <RunWith
                context={language}
                schemaObject={version._extras}
                input={example.input}
                model={model}
                token={token}
                usesVersionlessApi
              />
            ) : (
              <RunWith
                context={language}
                schemaObject={version._extras}
                input={example.input}
                token={token}
                usesVersionlessApi={false}
                model={version._extras.model}
                version={version}
              />
            ),
        }}
        // @ts-ignore
        token={token}
        version={version}
        usesVersionlessApi={usesVersionlessApi}
        {...gsp}
      />
    </MDXPageWithToc>
  );
}
